module.exports = __webpack_public_path__ + "img/number.59662518.svg";